import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../RootState';
import {settings} from '@/plugins/settings';
import {helpdeskAxios} from '@/plugins/helpdeskAxios';
import responseHandler from '@/plugins/errorHandling';

export interface IEmailSignature {
  id: number;
  name: string;
  user_email: string;
  body: string;
  created_at: string;
  updated_at: string;
}

interface SignaturesState {
  signatures: IEmailSignature[];
  errors: any;
}

const state: SignaturesState = {
  signatures: [],
  errors:     {},
};

const getters: GetterTree<SignaturesState, RootState> = {
  signatures: (state) => state.signatures,
};

const mutations: MutationTree<SignaturesState> = {
  errors(state, payload: any) { state.errors = payload; },
  signaturesLoaded(state, payload: IEmailSignature[]) { state.signatures = payload; },
  signatureCreated(_state, _payload: any) {},
  signatureUpdated(state, payload: IEmailSignature) {
    const idx = state.signatures.findIndex(s => s.id === payload.id);
    if (idx !== -1) state.signatures.splice(idx, 1, payload);
  },
  signatureDeleted(_state, _payload: any) {},
};

const BASE = () => settings.helpdeskEndpoint + 'v1/signatures';

const actions: ActionTree<SignaturesState, RootState> = {
  fetchAll: ({commit}, params?: {user_email?: string}) => {
    const query = new URLSearchParams();
    if (params && params.user_email) query.set('user_email', params.user_email);
    const qs = query.toString() ? '?' + query.toString() : '';
    return responseHandler.handle(
      () => helpdeskAxios({url: BASE() + qs, method: 'GET'}),
      commit, 'signaturesLoaded',
    );
  },

  create: ({commit}, data: Partial<IEmailSignature>) => responseHandler.handle(
    () => helpdeskAxios({url: BASE(), method: 'POST', data}),
    commit, 'signatureCreated', null, false,
  ),

  update: ({commit}, {id, data}: {id: number; data: Partial<IEmailSignature>}) => responseHandler.handle(
    () => helpdeskAxios({url: BASE() + '/' + id, method: 'PATCH', data}),
    commit, 'signatureUpdated',
  ),

  delete: ({commit}, id: number) => responseHandler.handle(
    () => helpdeskAxios({url: BASE() + '/' + id, method: 'DELETE'}),
    commit, 'signatureDeleted', null, false,
  ),
};

export const helpdeskEmailSignaturesModule: Module<SignaturesState, RootState> = {
  namespaced: true, state, getters, mutations, actions,
};
